"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Events = require("../constants/Events");
var _ServiceRegistry = _interopRequireDefault(require("../util/ServiceRegistry"));
var _EnvUtil = require("../util/EnvUtil");
var _AppUtil = require("../util/AppUtil");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2020 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
class EventHandlerService {
  constructor() {
    this._eventListenOn = [];
    this._enablePDFAnalytics = false;
    this._enableFilePreviewEvents = false;
    this._enablePageOverlayEvents = true;
    this._enableInternalEvents = false;
    this._eventListenerMap = {};
  }
  initialize(isViewSDKPublic = false) {
    this._loggingService = _ServiceRegistry.default.getService("LoggingService");
    this._isViewSDKPublic = isViewSDKPublic;
    this._registerDefaultEvents();
  }
  registerEventListener(eventType, eventListener) {
    const registerListener = (type, listener) => {
      if (!this._eventListenerMap[type]) {
        this._eventListenerMap[type] = [];
      }
      this._eventListenerMap[type].push(listener);
    };
    if (Array.isArray(eventType)) {
      eventType.forEach(type => registerListener(type, eventListener));
    } else {
      registerListener(eventType, eventListener);
    }
  }
  setEventListener(eventListener, options) {
    this._eventListener = eventListener;
    if (options && options.listenOn && options.listenOn.length > 0) {
      this._eventListenOn = options.listenOn;
    }
    if (options && options.enablePDFAnalytics) {
      this._enablePDFAnalytics = true;
    }
    if (options && options.enableInternalEvents) {
      this._enableInternalEvents = true;
    }
    if (options && options.enableFilePreviewEvents) {
      this._enableFilePreviewEvents = true;
    }
    if (options && options.enableAnnotationEvents) {
      this._enableAnnotationEvents = true;
    }
    if (options && typeof options.enablePageOverlayEvents === "boolean") {
      this._enablePageOverlayEvents = options.enablePageOverlayEvents;
    }
    if (this._isViewSDKPublic) {
      this._enableInternalEvents = false;
    }
  }
  _internalEventListner(event) {
    if (this._eventListenerMap[event.type] && this._eventListenerMap[event.type].length > 0) {
      this._eventListenerMap[event.type].forEach(eventListener => eventListener({
        type: event.type,
        data: event.data
      }));
    }
  }
  _exposeEvent(data) {
    if (typeof this._eventListener !== "function") {
      return;
    }
    const eventType = data.type;
    let exposeEvent = true;
    if (_Events.InternalEvents[eventType]) {
      exposeEvent = this._enableInternalEvents;
    } else if (_Events.FilePreviewEvents[eventType]) {
      exposeEvent = this._enableFilePreviewEvents;
    } else if (_Events.OverlayEvents[eventType]) {
      exposeEvent = this._enablePageOverlayEvents;
    } else if (_Events.PDFAnalyticsEvents[eventType]) {
      exposeEvent = this._enablePDFAnalytics;
    } else if (_Events.AnnotationEvents[eventType]) {
      exposeEvent = this._enableAnnotationEvents;
    }
    if (!exposeEvent) {
      return;
    }
    if (this._eventListenOn.length !== 0 && this._eventListenOn.indexOf(eventType) === -1) {
      return;
    }
    const event = {
      type: eventType,
      data: data.data
    };
    this._eventListener(event);
    if ((0, _AppUtil.isDocumentViewUpdateEvent)(event.type)) {
      this._handleDocumentStateUpdate(event);
    }
  }
  _handleDocumentStateUpdate(event) {
    const {
      type: eventType,
      data: eventData
    } = event;
    const eventTypeGroup = (0, _AppUtil.getDocViewUpdateEventTypeGroup)(eventType);
    const docState = _ServiceRegistry.default.getService("AppStore").documentViewUpdateEventData;
    if (!docState[eventTypeGroup]) {
      docState[eventTypeGroup] = {};
    }
    docState[eventTypeGroup] = _objectSpread(_objectSpread({}, docState[eventTypeGroup]), {}, {
      [eventType]: eventData
    });
    _ServiceRegistry.default.getService("AppStore").documentViewUpdateEventData = _objectSpread({}, docState);
    this._eventListener({
      type: _Events.InternalEvents.DOCUMENT_VIEW_UPDATE_EVENT,
      data: docState
    });
  }
  _registerDefaultEvents() {
    this.registerEventListener(_Events.InternalEvents.RELOAD_APP, this._reloadListener.bind(this));
    if (this._isViewSDKPublic) {
      this.registerEventListener(_Events.InternalEvents.GO_TO_LOCATION, this._gotoEventListener);
      this.registerEventListener(_Events.InternalEvents.CLOSE_WINDOW, this._onCloseEventListener);
    }
  }
  _gotoEventListener(event) {
    if ((0, _EnvUtil.isValidUrl)(event.data, ["https:"])) {
      window.location.href = event.data;
    } else {
      this._loggingService.logExternal("Invalid url in the event data");
    }
  }
  _onCloseEventListener() {
    window.close();
  }
  _shouldTakeActionOnInternalEvents() {
    if (this._isViewSDKPublic) {
      return true;
    }
    return _ServiceRegistry.default.getService("AppStore").getConfig().takeActionOnInternalEvents;
  }
  _reloadListener() {
    if (this._shouldTakeActionOnInternalEvents()) {
      window.location.reload();
    }
  }
  handleEvent(eventData) {
    this._internalEventListner(eventData);
    this._exposeEvent(eventData);
  }
}
exports.default = EventHandlerService;